import React, { FC, useMemo } from 'react';
import { Title } from 'ui-library';
import { useTranslation } from 'react-i18next';
import { ApplicationTypesEnum, ProductApplicationsProps } from './Applications.types';
import SingleApplicationRow from './SingleApplicationRow';
import './Applications.css';

const Applications: FC<ProductApplicationsProps> = ({
    emptyFormDocuments,
    applications,
    isAdvisoryExpired,
    is3aVB,
    hasDocumentESignAccess,
    isAllIdDocumentsSigned,
    apiError,
    canCompleteFollowUpInvestorProfileApplication,
    hasAccessToReUpload,
}) => {
    const { t } = useTranslation();

    const sellApplications = useMemo(() => applications?.filter(item => item?.typeKey === ApplicationTypesEnum.SELL), [applications]);
    const productApplications = useMemo(() => applications?.filter(item => item?.typeKey !== ApplicationTypesEnum.SELL), [applications]);

    return (
        <>
            {productApplications?.length > 0 ? (
                <div className="product-applications">
                    <Title type={2}>
                        {t('ApplicationDetails.AdvisorySection.ProductApplications')}
                    </Title>
                    {productApplications?.map((application, index) => (
                        <SingleApplicationRow
                            key={application?.applicationId || index}
                            data={application}
                            isAdvisoryExpired={isAdvisoryExpired}
                            is3aVB={is3aVB}
                            hasDocumentESignAccess={hasDocumentESignAccess}
                            isAllIdDocumentsSigned={isAllIdDocumentsSigned}
                            apiError={apiError}
                            canCompleteFollowUpInvestorProfileApplication={canCompleteFollowUpInvestorProfileApplication}
                            hasAccessToReUpload={hasAccessToReUpload}
                        />
                    ))}
                </div>
            ) : <></>}

            {sellApplications?.length > 0 ? (
                <div className="product-applications mt-32">
                    <Title type={2}>
                        {t('ApplicationDetails.AdvisorySection.CaseOrders')}
                    </Title>
                    {sellApplications?.map((application, index) => (
                        <SingleApplicationRow
                            emptyFormDocuments={emptyFormDocuments}
                            key={application?.applicationId || index}
                            data={application}
                            isAdvisoryExpired={isAdvisoryExpired}
                            is3aVB={is3aVB}
                            hasDocumentESignAccess={hasDocumentESignAccess}
                            isAllIdDocumentsSigned={isAllIdDocumentsSigned}
                            apiError={apiError}
                            canCompleteFollowUpInvestorProfileApplication={canCompleteFollowUpInvestorProfileApplication}
                        />
                    ))}
                </div>
            ) : <></>}
        </>
    );
};

export default Applications;
